import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-multi-lang";
import { agentDeleteStart } from "../../store/slices/AgentSlice";
import { ButtonLoader } from "../Helper/Loader";

const AgentDeleteModal = ({ show, onHide, agent }) => {
  const dispatch = useDispatch();
  const t = useTranslation("agent_delete");
  const agentDelete = useSelector((state) => state.agent.agentDelete);

  if (!agent) return null;

  const isDeleting =
    agentDelete.buttonDisable &&
    agentDelete?.data?.merchant_agent_id === agent?.id;

  const handleDelete = () => {
    dispatch(agentDeleteStart({ merchant_agent_id: agent.id }));
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-1">{t("description")}</p>
        <div className="fw-semibold">{agent?.name || agent?.email}</div>
        <div className="text-muted small">{agent?.email}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide}>
          {t("cancel")}
        </Button>
        <Button
          variant="danger"
          onClick={handleDelete}
          disabled={agentDelete.buttonDisable}
        >
          {isDeleting ? <ButtonLoader /> : t("delete")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AgentDeleteModal;
